import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Loader from "Components/UI/Loader";
import { getLocalStorage } from "Network/ApiService";
import { ls_vars } from "Library/Constants";
// Images
import images from "Assets/images";
// css
import "../style.css";
// import "Components/Core/BookingFormModule/new-booking-form.css";
import { useApiCall } from "Hooks/useApiCall";
import {
  createEquipment,
  getEquipmentTypes,
  updateEquipment,
} from "Network/Core/EquipmentMaster/equipment";
import { EquipmentType } from "Network/Core/EquipmentMaster/types";
import React from "react";
import { useTranslationCheck } from "Hooks/useTranslationCheck";

export interface EquipmentMasterModalProps {
  handleSubmit?: any;
  handleClose?: any;
  data: [];
}

const MasterCopyModal = ({
  handleSubmit,
  handleClose,
  data,
}: EquipmentMasterModalProps) => {
  const project = getLocalStorage(ls_vars.PROJECT_DATA);
  const site = getLocalStorage(ls_vars.PROJECT_SITE_ID);
  const region = getLocalStorage(ls_vars.REGION_ID);
  const { t, tCheck } = useTranslationCheck();
  const { call } = useApiCall();
  const [selectAll, setSelectAll] = useState(true);
  const [equipment, setEquipment] = useState<EquipmentType>({
    name: "",
    category: "",
    brand: "",
    model: "",
    fuelType: "",
    emissionFactor: 0.0,
    tempEmissionFactor: 0.0, // Add any other fields here with default values
  });

  const [isLoading, setIsLoading] = useState(false);
  const [equipmentTypesOptions, setEquipmentTypesOptions] =
    useState<any[]>(data);

  const handleCreateEquipmentSubmit = async (e: any) => {
    e.preventDefault();
    call(
      () => createEquipment(equipment, region, project.ref, site),
      (data) => {
        setIsLoading(false);
        handleClose();
      }
    );
    // setIsLoading(false);
  };

  const handleChangeCheckBox = (e: any, type: any) => {
    const { checked } = e.target;
    setEquipmentTypesOptions((prev) =>
      prev.map((item) => {
        const match = item.value === type.value;
        return match ? { ...item, enabled: checked } : item;
      })
    );
  };

  const handleSelectAll = () => {
    setEquipmentTypesOptions((prev) =>
      prev.map((item) => ({
        ...item,
        enabled: selectAll,
      }))
    );
    setSelectAll((prev) => !prev);
  };

  return (
    <>
      {isLoading && <Loader />}
      <div
        className="modal fade  show vc-user-invite"
        id="invite_user_Modal"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable ">
          <div className="modal-content">
            <div className="modal-header">
              <div className="invite-user-header">
                <h2 className="text-left">
                  {t("Translation.copy_from_master")}
                </h2>
              </div>
              <div className="invite-user-header vc-invite-from-procore-link">
                <Link onClick={handleClose} to="">
                  {t("Translation.close")}
                  <img src={images.cross} alt="" />
                </Link>
              </div>
            </div>
            <div className="modal-body">
              <div className="custom-form ">
                <form
                  onSubmit={(e) => {
                    e.preventDefault(); 
                    const selectedItems = equipmentTypesOptions.filter(
                      (item) => item.enabled
                    );
                    handleSubmit(selectedItems); 
                  }}
                >
                  <div>
                    {equipmentTypesOptions?.length !== 0 && (
                      <table
                        className="table field-table"
                      >
                        <tbody className="custom-table-div-scroll" style={{overflowY: "auto" }}>
                          {equipmentTypesOptions?.map((item, index) => (
                            <tr key={item.value}>
                              <td>
                                <div
                                  className="filtercheck-item"
                                  style={{ padding: 0 }}
                                >
                                  <span className="fci-title">
                                    {tCheck(item.label)}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div
                                  className="filtercheck-item"
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    padding: 0,
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    name={item.value}
                                    onChange={(e) =>
                                      handleChangeCheckBox(e, item)
                                    }
                                    checked={item.enabled}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn theme-btn"
                      onClick={handleSelectAll}
                    >
                      {selectAll ? (t("Translation.Select All")) : t("Translation.Deselect All")}
                    </button>
                    <button type="submit" className="btn theme-btn">
                      {t("Translation.submit")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MasterCopyModal;
